// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__10r5c","footer":"ModalCreateQualiphyProcedure_footer__2PF5x","additionData":"ModalCreateQualiphyProcedure_additionData__3B5CK"};